import openNewTab from '../utility/openNewTab';
import { findEngineDriver, getConnectionLabel } from 'dbgate-tools';
import { getAppliedCurrentSchema, getExtensions } from '../stores';
export default function newTable(connection, database) {
    var _a, _b, _c, _d;
    const tooltip = `${getConnectionLabel(connection)}\n${database}`;
    const driver = findEngineDriver(connection, getExtensions());
    openNewTab({
        title: 'Table #',
        tooltip,
        icon: 'img table-structure',
        tabComponent: 'TableStructureTab',
        props: {
            conid: connection._id,
            database,
        },
    }, {
        editor: {
            current: {
                pureName: 'new_table',
                schemaName: (_a = getAppliedCurrentSchema()) !== null && _a !== void 0 ? _a : (_b = driver === null || driver === void 0 ? void 0 : driver.dialect) === null || _b === void 0 ? void 0 : _b.defaultSchemaName,
                columns: (_d = (_c = driver.dialect) === null || _c === void 0 ? void 0 : _c.defaultNewTableColumns) !== null && _d !== void 0 ? _d : [
                    {
                        columnName: 'id',
                        dataType: 'int',
                        notNull: true,
                        autoIncrement: true,
                    },
                ],
                primaryKey: {
                    constraintType: 'primaryKey',
                    columns: [
                        {
                            columnName: 'id',
                        },
                    ],
                },
            },
        },
    }, {
        forceNewTab: true,
    });
}
